import React from "react";
// Common Components
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
// Services
import {
  FileResponse,
  getConvertToGoldBarDeposit,
  getConvertToGoldBarDepositExcel,
} from "src/Requests/imePortfolio";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";
// Types
import {
  ITable2TableReport,
  ITable2SearchParams,
} from "src/Interfaces/imePortfolio";
import PortfoTableSection from "./PortfoTableSection";

interface IProps {
  searchParams: ITable2SearchParams;
  totalRefreshFlag: boolean;
}

const GoldTable = ({ searchParams, totalRefreshFlag }: IProps) => {
  const productsFileRef = React.useRef<HTMLAnchorElement>(null);
  const [loading, setLoading] = React.useState(false);

  const getLink = (fileResponse: FileResponse, name: string) => {
    if (!productsFileRef.current) return;

    const blobUrl = URL.createObjectURL(fileResponse.blob);

    const link = productsFileRef.current;
    link.href = blobUrl;
    link.setAttribute("download", fileResponse.filename);
    link.target = "_blank";

    link.click();
    URL.revokeObjectURL(blobUrl);
  };

  const getExcelFileHandler = () => {
    if (loading) return;
    setLoading(true);
    getConvertToGoldBarDepositExcel(searchParams)
      .then((res) => {
        getLink(res, "portfo");
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <PortfoTableSection title="تبدیل به گواهی سپرده شمش طلا">
      <TableTemplate<ITable2SearchParams, ITable2TableReport>
        getDataTable={getConvertToGoldBarDeposit}
        tableWrapperClassname="w-full justify-start"
        TableUI={({ reports, onAction, setSortingType, sortingType }) => (
          <CommonTableUI
            reports={reports}
            sortingType={sortingType}
            setSortingType={setSortingType}
            tableBoxClassName="!mx-0"
            tableHeaderClassName="!bg-sky-50 hover:!bg-sky-100"
            onAction={onAction}
            refreshFlag={totalRefreshFlag}
          />
        )}
        withSort
        searchParameters={searchParams}
      />
    </PortfoTableSection>
  );
};

export default GoldTable;
